import { FeedbackOverview } from "@/components/feedback/feedback-overview.tsx";
import { m } from "@/paraglide/messages.js";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { pageTitle } from "@/utils/page-title.ts";

export const Route = createFileRoute("/_authenticated/dashboard/feedback")({
	beforeLoad: ({ context }) => {
		if (!context.auth.user?.isAdmin) {
			throw redirect({ to: "/dashboard" });
		}
	},
	component: RouteComponent,
	head: () => ({
		meta: [{ title: pageTitle(m.feedback_admin_title()) }],
	}),
});

function RouteComponent() {
	return <FeedbackOverview />;
}
